import { api, getToken } from "./api";
import { renderChat } from "./chat";
import { renderLogin } from "./login";
import { renderBilling } from "./billing";
import { getLang, setLang, t, langOptions } from "./i18n";

const app = document.getElementById("app")!;
const loginLink = document.querySelector<HTMLAnchorElement>(".login-link")!;
const meEl = document.querySelector<HTMLElement>(".me")!;

/** Видимость login/me — только по наличию токена, не зависит от /credits */
function syncAuthUI(creditsTxt?: string): void {
  const token = getToken();
  if (!token) {
    loginLink.hidden = false;
    meEl.hidden = true;
    return;
  }
  loginLink.hidden = true;
  if (creditsTxt) {
    meEl.textContent = creditsTxt;
    meEl.hidden = false;
  }
}

async function refreshMe(): Promise<void> {
  syncAuthUI();
  if (!getToken()) return;
  try {
    const c = await api.credits();
    syncAuthUI(`${c.credits.toLocaleString()} кр`);
  } catch {
    syncAuthUI();
  }
}

async function route(): Promise<void> {
  const hash = location.hash.slice(2) || "";
  // root → редирект на чат или логин
  if (hash === "" || hash === "/") {
    location.hash = "#/chat";
    return;
  }
  // подсветка вкладки
  document.querySelectorAll<HTMLAnchorElement>(".nav a[data-route]").forEach(a => {
    a.classList.toggle("active", a.dataset.route === hash);
  });
  app.innerHTML = "";
  app.classList.remove("chat-mode");
  if (hash === "chat") return renderChat(app);
  if (hash === "billing") return renderBilling(app);
  if (hash === "login") return renderLogin(app, refreshMe);
  app.innerHTML = `<div class="card empty">Не найдено</div>`;
}

function applyI18n(): void {
  document.querySelectorAll<HTMLElement>("[data-i18n]").forEach(el => {
    el.textContent = t(el.dataset.i18n!);
  });
  const btn = document.querySelector<HTMLButtonElement>("#lang-toggle");
  if (btn) {
    const opts = langOptions();
    const cur = getLang();
    const next = opts[(opts.findIndex(o => o.code === cur) + 1) % opts.length];
    btn.textContent = next.label;
    btn.title = `Switch to ${next.label}`;
  }
}

document.querySelector("#lang-toggle")?.addEventListener("click", () => {
  const opts = langOptions();
  const cur = getLang();
  const next = opts[(opts.findIndex(o => o.code === cur) + 1) % opts.length];
  setLang(next.code);
});

window.addEventListener("i18n:change", () => {
  applyI18n();
  route();
});

window.addEventListener("hashchange", () => { route(); });
window.addEventListener("altuwka:auth-expired", () => {
  syncAuthUI();
});
applyI18n();
refreshMe().then(route);
